import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { Assignment } from '../../../api/app-types/assignment';
import { DB_PHASES } from '../../../api/app-types/phase.app';
import { TranslocoPipe } from '@jsverse/transloco';
import { LvrButton } from '../lvr-button/lvr-button';

@Component({
	selector: 'lvr-assignment-draft-create-dialog',
	imports: [MatDialogModule, MatRadioGroup, MatRadioButton, ReactiveFormsModule, TranslocoPipe, LvrButton],
	templateUrl: './assignment-draft-create-dialog.html',
	styleUrl: './assignment-draft-create-dialog.scss',
})
export class AssignmentDraftCreateDialog {
	private readonly fb = inject(FormBuilder);
	public readonly self = inject(MatDialogRef<AssignmentDraftCreateDialog>);
	public readonly assignment = inject<{ assignment: Assignment }>(MAT_DIALOG_DATA).assignment;

	public get canMoveToP2() {
		if (this.assignment.phaseId === DB_PHASES.P0 || this.assignment.phaseId === DB_PHASES.P1) return true;

		return false;
	}

	public get canMoveToP3() {
		if (
			this.assignment.phaseId === DB_PHASES.P0 ||
			this.assignment.phaseId === DB_PHASES.P1 ||
			this.assignment.phaseId === DB_PHASES.P2
		)
			return true;

		return false;
	}

	public readonly form = this.fb.group({
		targetPhaseId: this.fb.control<number | null>(null, [Validators.required]),
	});

	public submit() {
		if (this.form.valid) {
			const targetPhaseId = this.form.value.targetPhaseId;
			this.self.close(targetPhaseId);
		}
	}
}
